import { Card, CardContent, CardHeader, Chip, Divider } from "@mui/material";
import { colors } from "common";
import { H2, H4, H6, Paragraph, Tiny } from "components/Typography";
import { UserRma } from "modules/pc-worth-care/types";
import { FC, memo, useState } from "react";

type Props = { rma?: UserRma };

const Component: FC<Props> = ({ rma }) => {
  const [showMore, setShowMore] = useState(false);

  return (
    <Card
      elevation={2}
      key={rma?.transaction_no}
      sx={{
        mb: 2,
        border: "1px solid",
        borderRadius: 2,
      }}
    >
      <CardHeader
        title={
          <>
            <H4 style={{ color: colors.success }}>{rma?.product_name}</H4>
            <H6>
              Serial No: {rma?.serial_no} | Transaction No:{" "}
              {rma?.transaction_no}
            </H6>
          </>
        }
      />
      <Divider sx={{ borderColor: "black", borderBottomWidth: 2 }} />
      <CardContent>
        <H6>
          🔎 Status: {<Chip size="small" color="primary" label={rma?.status} />}
        </H6>
        <H6 style={{ marginTop: 2 }}>
          📋 Reported Problem: {rma?.reported_problem}
        </H6>

        <Paragraph
          style={{
            display: "-webkit-box",
            WebkitLineClamp: showMore ? "none" : 2,
            WebkitBoxOrient: "vertical",
            overflow: "hidden",
            textOverflow: "ellipsis",
            marginTop: 10,
          }}
        >
          Reported on {rma?.created_at}. {rma?.turnaround_time} has passed
          since.
        </Paragraph>
      </CardContent>
    </Card>
  );
};

export const RmaInfoCard = memo(Component);
